/*
  7Raw rich text: wraps every table inside a .r7-rte block in a focusable, labelled region so keyboard
  users can scroll wide tables (.r7-rte__table in assets/7r-page.css owns the overflow). page.content
  cannot be wrapped in Liquid, so this runs on load and again when the theme editor re-renders a section.
  The accessible name is the table caption, else the block's data-r7-table-label. Idempotent.
*/
(() => {
  if (window.R7RteTables) return;

  const wrapTables = (scope) => {
    scope.querySelectorAll('.r7-rte table').forEach((table) => {
      const parent = table.parentElement;
      if (!parent || parent.classList.contains('r7-rte__table')) return;
      const rte = table.closest('.r7-rte');
      const caption = table.caption ? table.caption.textContent.trim() : '';
      const wrap = document.createElement('div');
      wrap.className = 'r7-rte__table';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('aria-label', caption || (rte && rte.dataset.r7TableLabel) || 'Table');
      parent.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  };

  window.R7RteTables = { wrap: wrapTables };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => wrapTables(document));
  } else {
    wrapTables(document);
  }
  document.addEventListener('shopify:section:load', (event) => wrapTables(event.target));
})();
